import { defineMessages } from "react-intl";

import MapTool from "@mapmycustomers/shared/enum/map/MapTool";

const messages = defineMessages({
  [MapTool.DROP_PIN]: {
    id: "map.toolbar.toolSelection.dropPin",
    defaultMessage: "Drop Pin",
    description: "Drop Pin button tooltip",
  },
  [MapTool.FIND_LEADS]: {
    id: "map.toolbar.toolSelection.findLeads",
    defaultMessage: "Find Leads",
    description: "Find Leads button tooltip",
  },
  [MapTool.LASSO]: {
    id: "map.toolbar.toolSelection.lasso",
    defaultMessage: "Lasso",
    description: "Lasso button tooltip",
  },
  [MapTool.PIN_LOCATION]: {
    id: "map.toolbar.toolSelection.pinLocation",
    defaultMessage: "Pin Location",
    description: "Pin Location button tooltip",
  },
  [MapTool.TAKE_SNAPSHOT]: {
    id: "map.toolbar.toolSelection.takeSnapshot",
    defaultMessage: "Take Snapshot",
    description: "Take Snapshot button tooltip",
  },
  selectBasemap: {
    id: "map.toolbar.toolSelection.selectBasemap",
    defaultMessage: "Select Basemap",
    description: "Select Basemap button tooltip",
  },
});

export default messages;
